export const publicationTemplateCatalog = Object.freeze([
  Object.freeze({ id: "entertainment@1.0.0", name: "Entertainment", description: "Dark editorial Entertainment theme in the legacy centered frame.", aliases: Object.freeze([]) }),
  Object.freeze({
    id: "classic-news",
    name: "Classic News",
    description: "The established SURGEDOME news layout.",
    aliases: Object.freeze(["Classic News"]),
  }),
  Object.freeze({
    id: "classic-newspaper@1.0.0",
    name: "Classic Newspaper",
    description: "The versioned newspaper presentation for high-density news publications.",
    aliases: Object.freeze(["classic-newspaper"]),
  }),
  Object.freeze({
    id: "technology@1.0.0",
    name: "Technology",
    description: "The versioned technology and product-news presentation.",
    aliases: Object.freeze(["technology", "Technology"]),
  }),
  Object.freeze({
    id: "magazine@1.0.0",
    name: "Magazine",
    description: "The versioned editorial magazine presentation.",
    aliases: Object.freeze(["magazine", "Magazine"]),
  }),
  Object.freeze({
    id: "surgezirc-corporate",
    name: "Corporate",
    description: "The corporate publication and company-news presentation.",
    aliases: Object.freeze([]),
  }),
]);

export function getSelectablePublicationTemplate(templateId) {
  return publicationTemplateCatalog.find(template => template.id === templateId || template.aliases.includes(templateId)) || null;
}

export function isSelectablePublicationTemplate(templateId) {
  return publicationTemplateCatalog.some(template => template.id === templateId);
}

// Normalize known aliases without redirecting unrelated legacy themes.
export function resolvePublicationTemplate(templateId) {
  return getSelectablePublicationTemplate(templateId)?.id || templateId || "classic-news";
}

export function isMagazineTemplate(templateId) {
  return resolvePublicationTemplate(templateId) === "magazine@1.0.0";
}
